import { Node } from 'reactflow'

import { DETECTION_DISTANCE_X, DETECTION_DISTANCE_Y } from '@ui/constants/pipelinesWorkflow'

export type Placement = 'left' | 'right' | 'top' | 'bottom'

interface Point {
  x: number
  y: number
}

interface Triangle {
  a: Point
  b: Point
  c: Point
}

//https://stackoverflow.com/questions/2049582/how-to-determine-if-a-point-is-in-a-2d-triangle
export const isInsideTrigon = (p: Point, triangle: Triangle) => {
  const { a, b, c } = triangle

  const as_x = p.x - a.x
  const as_y = p.y - a.y

  const s_ab = (b.x - a.x) * as_y - (b.y - a.y) * as_x > 0

  if ((c.x - a.x) * as_y - (c.y - a.y) * as_x > 0 == s_ab) return false
  if ((c.x - b.x) * (p.y - b.y) - (c.y - b.y) * (p.x - b.x) > 0 != s_ab) return false
  return true
}

export const getRelationType = (targetNode: Node, closestNode: Node | null): Placement | null => {
  if (!closestNode) return null

  if (!targetNode?.positionAbsolute || !targetNode?.positionAbsolute) return null

  if (!closestNode?.positionAbsolute || !closestNode?.positionAbsolute) return null
  if (!targetNode?.positionAbsolute || !targetNode?.positionAbsolute) return null

  const px = closestNode.positionAbsolute.x - targetNode.positionAbsolute.x
  const py = closestNode.positionAbsolute.y - targetNode.positionAbsolute.y

  // if the nodes are on top of each other, return 'right'
  if (px === 0 && py === 0) return 'right'

  /***********************
   *
   *    x:pos | x:neg
   *    y:pos | y:pos
   *   ---------------
   *    x:pos | x:neg
   *    y:neg | y:neg
   *
   * *********************/

  // Define the edges of the node. We will use these to create four triangles
  const topLeft = { x: DETECTION_DISTANCE_X, y: DETECTION_DISTANCE_Y }
  const topRight = { x: -DETECTION_DISTANCE_X, y: DETECTION_DISTANCE_Y }
  const bottomRight = { x: -DETECTION_DISTANCE_X, y: -DETECTION_DISTANCE_Y }
  const bottomLeft = { x: DETECTION_DISTANCE_X, y: -DETECTION_DISTANCE_Y }

  /************************
   *
   *  tl\        /tr
   *     \      /
   *      \    /
   *       \  /
   *        \/ [0,0]
   *       / \
   *      /   \
   *     /     \
   *  bl/       \br
   *
   * **********************/

  // Check to see if our node is inside any of the triangles
  const isInTop = isInsideTrigon({ x: px, y: py }, { a: topLeft, b: topRight, c: { x: 0, y: 0 } })
  const isInRight = isInsideTrigon({ x: px, y: py }, { a: topRight, b: bottomRight, c: { x: 0, y: 0 } })
  const isInBottom = isInsideTrigon({ x: px, y: py }, { a: bottomLeft, b: bottomRight, c: { x: 0, y: 0 } })
  const isInLeft = isInsideTrigon({ x: px, y: py }, { a: topLeft, b: bottomLeft, c: { x: 0, y: 0 } })

  if (isInLeft) return 'left'
  if (isInRight) return 'right'
  if (isInTop) return 'top'
  if (isInBottom) return 'bottom'

  return null
}
